
namespace RioERP.Orders {
    export class OrderInstallmentsColumns {
        static columnsKey = 'Orders.OrderInstallments';
    }
}